import { toTitleCase } from '@/react/common/string-utils';

import { Checkbox } from '@@/form-components/Checkbox';

import { TRIVY_SEVERITIES, TrivySeverity } from './types';

// Shown all at once rather than behind a select, so what is excluded stays
// visible - an unrecorded severity cannot be recovered without a rescan.
export function SeveritySelector({
  value,
  onChange,
}: {
  value: Array<string>;
  onChange: (severities: Array<string>) => void;
}) {
  function toggle(severity: TrivySeverity, checked: boolean) {
    onChange(
      checked
        ? [...value, severity]
        : value.filter((candidate) => candidate !== severity)
    );
  }

  return (
    // min-h matches FormControl's standard input height so the row centres
    // against the label's first line rather than its top.
    <div className="flex min-h-[34px] flex-wrap items-center gap-x-6 gap-y-2">
      {TRIVY_SEVERITIES.map((severity) => (
        <Checkbox
          key={severity}
          id={`severity-${severity.toLowerCase()}`}
          label={toTitleCase(severity)}
          checked={value.includes(severity)}
          onChange={(e) => toggle(severity, e.target.checked)}
          data-cy={`vulnerability-scanning-severity-${severity.toLowerCase()}`}
        />
      ))}
    </div>
  );
}
